<app-table
  [actionColumnWidth]="300"
  [columns]="columns"
  [loading]="loading"
  [value]="documents"
  filename="MENU.DATENABLAGE">
  <p-fileUpload
    (uploadHandler)="uploadFiles($event)"
    [auto]="true"
    [chooseLabel]="'DATENABLAGE.ADD_FILE' | translate"
    [customUpload]="true"
    [multiple]="true"
    #fileUpload
    customAction
    mode="basic" />
  <ng-template
    (onClick)="download($event.row)"
    appActionButton
    icon="fal fa-arrow-down"
    labelKey="ACTIONS.DOWNLOAD"></ng-template>

  <ng-template
    (onClick)="delete($event.row)"
    appActionButton
    displayIf="canDelete"
    icon="fal fa-trash"
    labelKey="ACTIONS.DELETE"
    type="danger"></ng-template>
</app-table>

<p-dialog [closable]="false" [contentStyle]="{ height: '135px' }" [modal]="true" [visible]="uploading || deleting">
  <p-header>
    @if (uploading) {
      {{ 'DATENABLAGE.DOCUMENT_UPLOADING' | translate }}
    } @else if (deleting) {
      {{ 'DATENABLAGE.DOCUMENT_DELETING' | translate }}
    }
  </p-header>
  <div class="flex justify-center">
    <p-progressSpinner styleClass="w-4rem"></p-progressSpinner>
  </div>
</p-dialog>
